import React from "react";
import moment from "moment";
import dateFns from "date-fns";
import { images } from "../../../../../assets";

interface CalendarYearsProps {
  newDate: Date;
  showYears: boolean;
  minDate?: string;
  isAllowSelect: (date: Date, monthSearch?: boolean, yearSearch?: boolean) => boolean;
  onClickDate: (clickedDate: Date, close: boolean, forceDate?: boolean) => void;
  setShowYears: React.Dispatch<React.SetStateAction<boolean>>;
}

const CalendarYears = ({
  newDate,
  showYears,
  minDate,
  isAllowSelect,
  onClickDate,
  setShowYears,
}: CalendarYearsProps) => {
  const onSelectYear = (year: number) => {
    const selected = dateFns.setYear(newDate, year);
    onClickDate(selected, false, true);
  };

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 5;
    const minYear = minDate ? moment(minDate).get("year") : maxYear - 200;
    const years = [];

    for (let i = maxYear; i >= minYear; i--) {
      let child = [<p key={i}>{i}</p>];
      const yearDate = dateFns.setYear(newDate, i);
      years.push(
        <li
          className={`${!isAllowSelect(yearDate, false, true) ? "no-allow" : ""}`}
          key={i}
          onClick={() => onSelectYear(i)}
        >
          {child}
        </li>
      );
    }
    return years;
  };

  return (
    <div className={"year-select " + (showYears ? "active" : "")}>
      <div className="year-select-close" onClick={() => setShowYears(false)}>
        <img src={images.IconCrossGreen} alt="cerrar seleccion de año" />
      </div>
      <ul>{getYears()}</ul>
    </div>
  );
};

export default CalendarYears;
